import React from 'react';
import './OdProductCard.scss';
import { getProductPrice, removeDomainName } from '../../../helper';

const OdProductCard = ({ product, index, currentTab }) => {
  const price = getProductPrice(product);
  const brandName = product?.brand_name;
  const productUrl = product?.product_url;
  const color = product?.color;
  const model = product?.model_name;
  const type = product?.type;
  const productImage = product?.image_url;

  const handleProductClick = () => {
    if (productUrl?.length > 0 && productUrl.includes('sg/en/')) {
      window.open(`/${removeDomainName(productUrl)}`, '_self');
    } else {
      window.open(`/sg/en/${removeDomainName(productUrl)}`, '_self');
    }
  };

  const Tag = () => {
    if (Number(currentTab) === 91344 || Number(currentTab) === 18666) {
      return (
        <span className="odProductCard__crown">
          {index <= 2 && (
            <img
              alt="best sellers"
              className="odProductCard__crownImg"
              src={`https://static.lenskart.com/media/owndays/minified/crown-${index + 1}.webp`}
            />
          )}
          #{index + 1}
        </span>
      );
    }

    return <div className="odProductCard__new">New</div>;
  };

  return (
    <div className="odProductCard" onClick={handleProductClick}>
      <Tag />
      <div className="odProductCard__thumbnail">
        <img
          alt={model}
          className="odProductCard__image"
          src={
            productImage ||
            'https://static.lenskart.com/media/owndays/desktop/img/od-misc/no-image.jpg'
          }
        />
      </div>

      <div className="odProductCard__details">
        <div>
          <h3 className="odProductCard__name">{brandName}</h3>
          <div className="odProductCard__modelName">{model}</div>
        </div>
        <div className="odProductCard__price">${price}</div>
      </div>
    </div>
  );
};

export default OdProductCard;
